import selectLazy from 'yoda-site-components/lib/lazy/selectors/selectLazy';
import { createSelector } from 'reselect';

export default selectLazy;

export const selectPageLoaded = createSelector([selectLazy], (lazy) => lazy.pageLoaded || false);
